{
  "name": "patient",
  "version": "2.33.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=5200 --hmr=false --host 0.0.0.0 --open",
    "start-stest-node": "node server.js",
    "start-stest": "npm run build && node server.js",
    "build": "ng build --configuration=production --aot=true --optimization=true",
    "build:stag": "ng build --configuration=stag --aot=true --optimization=true",
    "cy:open": "start-server-and-test start-stest http://localhost:4200 cypress:open",
    "cy:run": "start-server-and-test start-stest http://localhost:4200 cypress:run",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "update-angular": "ng update @angular/core @angular/cli @angular/cdk @angular-devkit/build-angular @angular/compiler-cli @angular/material",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org mar-saude --project patient ./dist/patient && sentry-cli sourcemaps upload --org mar-saude --project patient ./dist/patient",
    "changelog-version": "node generate-changelog-update-version.js",
    "commit-version": "git add . && git commit -m'Version name: '$(grep -m1 version package.json | awk -F: '{ print $2 }' | sed 's/[\", ]//g')''",
    "release": "bash scripts/run-e2e.sh && npm run changelog-version && npm run commit-version && git push && git checkout main && git pull  && git merge --no-ff dev && git push && git checkout -",
    "release-hotfix": "bash scripts/run-e2e.sh && npm run changelog-version && npm run commit-version && git push && git checkout main && git pull",
    "release-fast": "npm run changelog-version && npm run commit-version && git push && git checkout main && git pull  && git merge --no-ff dev && git push && git checkout -",
    "e2e": "start-server-and-test start http://localhost:4200 cypress:open",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@amplitude/analytics-browser": "^2.17.6",
    "@angular/animations": "^20.1.0",
    "@angular/cdk": "^20.1.0",
    "@angular/common": "^20.1.0",
    "@angular/compiler": "^20.1.0",
    "@angular/core": "^20.1.0",
    "@angular/forms": "^20.1.0",
    "@angular/material": "^20.1.0",
    "@angular/platform-browser": "^20.1.0",
    "@angular/platform-browser-dynamic": "^20.1.0",
    "@angular/router": "^20.1.0",
    "@ngx-formly/core": "^6.1.8",
    "@ngx-formly/material": "^6.1.8",
    "@sentry/angular": "^9.19.0",
    "@sentry/cli": "^2.45.0",
    "@tailwindcss/postcss": "^4.1.8",
    "@types/numeral": "^2.0.5",
    "@types/pdfjs-dist": "^2.10.378",
    "async-mutex": "^0.5.0",
    "browserslist": "^4.24.4",
    "dayjs": "^1.11.8",
    "express": "^4.18.2",
    "json-logic-js": "^2.0.5",
    "libheif-js": "^1.18.2",
    "lottie-web": "^5.13.0",
    "marked": "^15.0.6",
    "mime": "^2.6.0",
    "ng2-currency-mask": "^13.0.3",
    "ngx-captcha": "^14.0.0",
    "ngx-file-drop": "^16.0.0",
    "ngx-flexible-layout": "^20.0.0",
    "ngx-image-cropper": "^9.1.5",
    "ngx-lottie": "^13.0.1",
    "ngx-mask": "^16.2.0",
    "numeral": "^2.0.6",
    "path": "^0.12.7",
    "path-to-regexp": "^8.2.0",
    "pdfjs-dist": "^4.7.76",
    "rxjs": "^7.8.2",
    "swiper": "^11.2.3",
    "tailwindcss": "^4.1.8",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.1.0",
    "@angular/cli": "~20.1.0",
    "@angular/compiler-cli": "^20.1.0",
    "@types/json-logic-js": "^2.0.8",
    "@types/node": "^22.16.3",
    "@types/w3c-image-capture": "^1.0.11",
    "cypress": "^14.3.3",
    "material-symbols": "^0.31.9",
    "semver": "^7.6.3",
    "start-server-and-test": "^2.0.12",
    "typescript": "~5.8.3"
  }
}